import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import DateTime from '_class/DateTime';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
var Comments = /*#__PURE__*/function (_Component) {
  function Comments(props) {
    var _this;
    _classCallCheck(this, Comments);
    _this = _callSuper(this, Comments, [props]);
    /* Render methods - JREND */
    _defineProperty(_this, "renderUpdate", function (comment) {
      var _comment$createdBy, _comment$createdBy2;
      return /*#__PURE__*/React.createElement("div", {
        className: "comment",
        key: comment.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, "".concat(((_comment$createdBy = comment.createdBy) === null || _comment$createdBy === void 0 ? void 0 : _comment$createdBy.firstName) || '', " ").concat(((_comment$createdBy2 = comment.createdBy) === null || _comment$createdBy2 === void 0 ? void 0 : _comment$createdBy2.lastName) || ''), ' • ' + comment.text, ' • ' + new DateTime(comment.created).getShortDate(true)));
    });
    _defineProperty(_this, "renderComment", function (comment) {
      var _comment$createdBy3, _comment$createdBy4;
      return /*#__PURE__*/React.createElement("div", {
        className: "comment",
        key: comment.id
      }, comment.text, /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, "".concat(((_comment$createdBy3 = comment.createdBy) === null || _comment$createdBy3 === void 0 ? void 0 : _comment$createdBy3.firstName) || '', " ").concat(((_comment$createdBy4 = comment.createdBy) === null || _comment$createdBy4 === void 0 ? void 0 : _comment$createdBy4.lastName) || ''), ' • ' + new DateTime(comment.created).getShortDate(true)));
    });
    _this.state = {
      index: 5
    };
    return _this;
  }
  _inherits(Comments, _Component);
  return _createClass(Comments, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var adjustment = this.props.adjustment;
      return /*#__PURE__*/React.createElement("div", {
        className: "comment-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "comments"
      }, adjustment.comments.map(function (comment, index) {
        if (index > _this2.state.index) {
          return null;
        }
        if (comment.origin == 'USER') {
          return _this2.renderComment(comment);
        }
        if (comment.origin == 'SYSTEM') {
          return _this2.renderUpdate(comment);
        }
      }), adjustment.comments.length > this.state.index ? /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          _this2.setState({
            index: _this2.state.index + 5
          });
        }
      }, this.props.translate('Show more')) : null));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(Comments);